// import React, { useEffect, useState, useRef} from 'react';
// import { useParams } from 'react-router-dom';
// import Sidebar from '../Sidebar';
// import axios from 'axios'

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// import {optionProductsByProducts, category, tags} from '../Options';
// import Multiselect from 'multiselect-react-dropdown';
// // import env from 'react-dotenv'

// export default function EditBlogs() {
//     {/**Images states */}
//     const [files, setFiles] = useState([]);
//     const [filenames, setFilenames] = useState([]);
//     const [uploadedFiles, setUploadedFiles] = useState([]);
//     const [message, setMessage] = useState('');
//     const [imagePreviews, setImagePreviews] = useState([]);

//     //province items
//     const [options, setOptions] = useState([])
//     const [options2, setOptions2] = useState([])
//     //options
//     const [selectedOptions, setSelectedOptions] = useState([])
//     const [selectedOptions2, setSelectedOptions2] = useState([])

    
//     const [form, setForm] = useState({
//         postTitle:'',
//         postLink: '',
//         postBody:'',
//         postExcerpt:'',
//         postCategory:[],
//         postAuthor:'',
//         postCreated:'',
//         images: [],
//     })

//     const ref1 = useRef()
//     const ref2 = useRef()
//     const ref3 = useRef()
//     const ref4 = useRef()
//     const ref5 = useRef()
//     const ref6 = useRef()
//     const ref7 = useRef()

//     useEffect(()=>{
//       setOptions(tags)
//       setOptions2(category)
//   }, [])

//       //date formatting fixture
//       function formatDateToYYYYMMDD(inputDate) {
//         const dateObject = new Date(inputDate);
//         const year = dateObject.getFullYear();
//         const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
//         const day = String(dateObject.getDate()).padStart(2, '0');
        
//         return `${year}-${month}-${day}`;
//         }



//     const {_id} = useParams()    
//     const token = sessionStorage.getItem('token')

//     const gerrit2 = async () =>{
//         const response = await fetch(`${process.env.REACT_APP_API_URL}/find-blogs/${_id}`,{
//           headers: {
//             'x-access-token': token
//           }
//         })
//         const data = await response.json()
//         setForm({...form, 
//         postTitle: data.postTitle,
//         postLink: data.postLink,
//         postBody: data.postBody,
//         postExcerpt: data.postExcerpt,
//         postTag: data.postTag,
//         postCategory: data.postCategory,
//         postAuthor:data.postAuthor,
//         postCreated:data.postCreated,
//         images: data.images,
//         })
//         setSelectedOptions(data.postTags)
//         setSelectedOptions2(data.postCategory)
//       }

//     useEffect(()=>{
//         gerrit2()
//     },[])


//     //dealing with multiple states
//     const handleSelectStateOptions =  (selectedList)=>{
//       setSelectedOptions(selectedList)
//     }
//     useEffect(()=>{
//       setForm({...form, postCategory: selectedOptions})
//     },[selectedOptions])

//     useEffect(()=>{
//      // console.log(form)
//     }, [form.postTags])

//     const handleSelectStateOptions2 =  (selectedList)=>{
//       setSelectedOptions2(selectedList)
//     }
//     useEffect(()=>{
//       setForm({...form, postTags: selectedOptions2})
//     },[selectedOptions2])

//     const organizeImagesIntoRows = () => {
//         const rows = [];
//         for (let i = 0; i < imagePreviews.length; i += 3) {
//           const row = imagePreviews.slice(i, i + 3);
//           rows.push(row);
//         }
//         return rows;
//       };
 
//     const addImageInput = () => {
//         const input = document.createElement('input');
//         input.type = 'file';
//         input.className = 'custom-file-input';
//         input.required = true;
//         input.multiple = false;
//         input.addEventListener('change', onChange);
//         input.click();
//       };
  
//       const onDeleteImage = (index) => {
//         const newFiles = [...files];
//         const newFilenames = [...filenames];
//         const newImagePreviews = [...imagePreviews];
//         newFiles.splice(index, 1);
//         newFilenames.splice(index, 1);
//         newImagePreviews.splice(index, 1);
//         setFiles(newFiles);
//         setFilenames(newFilenames);
//         setImagePreviews(newImagePreviews);
//       };


//     //   const onSubmit = async (e) => {
//     //     e.preventDefault();
//     //     await gerrit2();
//     //     const formData = new FormData();
//     //     formData.append('form', JSON.stringify(form));
//     //     // for (let i = 0; i < files.length; i++) {
//     //     //   formData.append('files', files[i]);
//     //     // }
//     //    // console.log("Heres the form data", formData.get('form'))
  
//     //     try {
//     //       const res = await axios.post(`http://localhost:8080/update-news/${_id}`, formData, {
//     //         headers: {
//     //           'Content-Type': 'multipart/form-data',
//     //         },
//     //         data: form
//     //       });
  
//     //       const newUploadedFiles = res.data;
//     //       setUploadedFiles(newUploadedFiles);
//     //       setMessage('Files Uploaded');
//     //      // console.log("This is the ", res.data)
//     //     } catch (err) {
//     //       if (err.response.status === 500) {
//     //         setMessage('There was a problem with the server');
//     //        // console.log("meh")
//     //       } else {
//     //         setMessage(err.response.data.msg);
//     //        // console.log("meh2")
//     //       }
//     //     }
//     //   };
  
//     //   const onSubmit = async(e) =>{
//     //     e.preventDefault()
//     //     try {
//     //         const req = await fetch(`http://localhost:8080/updated-news/${_id}`,{
//     //         method: "PUT",
//     //         headers: {
//     //           "Content-Type":"application/json",
//     //           'x-access-token':token
//     //         },
//     //         body: JSON.stringify(form)
//     //       })
//         // .then(console.log("Submitted successfully", form))
//     //     } catch (error) {
//     //        // console.log(error)
//     //     }
        
//     //   }


//         const onSubmit = async (e) => {
//         e.preventDefault();
//         const formData = new FormData();
//         formData.append('form', JSON.stringify(form));
//         if(files.length !== 0){
//             for (let i = 0; i < files.length; i++) {
//                 formData.append('files', files[i]);
//               }
//         }
//        // console.log("Heres the form data", formData.get('form'))
//         try {
//             await axios.put(`${process.env.REACT_APP_API_URL}/updated-blogs/${_id}`, formData, {
//                 headers:{
//                     "Content-Type":"multipart/form-data"
//                 }
//             })
//         } catch (error) {
//            // console.log(error)
//         }
//         }

    

//       const onChange = (e) => {
//         const selectedFiles = Array.from(e.target.files); 
//         const selectedFilenames = selectedFiles.map((file) => file.name);
      
//         const newImageObjects = selectedFiles.map((file) => ({
//           img_url: `${process.env.REACT_APP_API_URL}/blogs/${file.name}`, 
//           img_path: '/blogs/',
//         }));
      
//         setFiles([...files, ...selectedFiles]);
//         setFilenames([...filenames, ...selectedFilenames]);
      
//         setForm((prevObject) => ({
//           ...prevObject,
//           images: [...prevObject.images, ...newImageObjects],
//         }));
      
//         const previews = selectedFiles.map((file) => {
//           const reader = new FileReader();
//           return new Promise((resolve) => {
//             reader.onload = (e) => resolve(e.target.result);
//             reader.readAsDataURL(file);
//           });
//         });
      
//         Promise.all(previews).then((previewData) => {
//           setImagePreviews([...imagePreviews, ...previewData]);
//         });
//       };


//       const reset = ()=>{
//         setFilenames([])
//         setFiles([])
//         setUploadedFiles([])
//         setImagePreviews([])
//         setForm({
//             postTitle:'',
//             postLink: '',
//             postBody:'',
//             postExcerpt:'',
//             postCategory:'',
//             postAuthor:'',
//             postCreated:'',
//             images: [],
//         })
//         ref1.current.value = ''
//         ref2.current.value = ''
//         ref3.current.value = ''
//         ref4.current.value = ''
//         ref5.current.value = ''
//         ref6.current.value = ''
//         ref7.current.value = ''
//       }

//       useEffect(()=>{
//        // console.log(form)
//       },[form])
//   return (
// <>

// <div className="sidebar">
// <Sidebar/>
// </div>
//     <div id="bydrop">
//         <h1>Edit Blogs</h1>
//    <form onSubmit={onSubmit}>


// <div >
//     <label for="formGroupExampleInput2" class="form-label">Tags</label>
//             <Multiselect 
//               options={options}
//               displayValue='name' 
//               selectedValues={selectedOptions}
//               onSelect={handleSelectStateOptions}
//               onRemove={(selectedList) => {
//                 setSelectedOptions(selectedList);
//             }}
//               closeOnSelect={false}
//               avoidHighlightFirstOption
//             />
//     </div>
//     <div >
//     <label for="formGroupExampleInput2" class="form-label">Category</label>
//             <Multiselect 
//               options={options2}
//               displayValue='name' 
//               selectedValues={selectedOptions2}
//               onSelect={handleSelectStateOptions2}
//               onRemove={(selectedList) => {
//                 setSelectedOptions2(selectedList);
//             }}
//               closeOnSelect={false}
//               avoidHighlightFirstOption
//             />
//     </div>
// <div className="row">
//     <div className="col-md-6">
//             {/**Post Title */}
//     <label for="formGroupExampleInput" class="form-label">Title</label>
//     <div class="input-group input-group-sm mb-3">
//         <input required ref={ref1} value= {form.postTitle} onChange={e => setForm({...form, postTitle: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
//     </div>
//     </div>

//     <div className="col-md-6">
//             {/**Post Author*/}
//     <label for="formGroupExampleInput" class="form-label">Author</label>
//     <div class="input-group input-group-sm mb-3">
//         <input required ref={ref2} value= {form.postAuthor}  onChange={e => setForm({...form, postAuthor: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
//     </div>
//     </div>
// </div>

// <div className="row">
//     <div className="col-md-6">
//     {/**Post Link */}
//     <label for="formGroupExampleInput" class="form-label">Excerpt</label>
//     <div class="input-group input-group-sm mb-3">
//         <input ref={ref5} required  value= {form.postExcerpt}  onChange={e => setForm({...form, postExcerpt: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
//     </div>
//     </div>

//     <div className="col-md-6">

//     {/**Post Link */}
//     <label for="formGroupExampleInput" class="form-label">Link</label>
//     <div class="input-group input-group-sm mb-3">
//         <input ref={ref7} required  value= {form.postLink}  onChange={e => setForm({...form, postLink: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
//     </div>
//     </div>
// </div>

// <div className="row">
//     <div className="col-md-6">
//     {/**Post Creates */}
//     <label for="formGroupExampleInput" class="form-label">Date</label>
//     <div class="input-group input-group-sm mb-3">
//         <input required ref={ref3}  value= {formatDateToYYYYMMDD(form.postCreated)}  onChange={e => setForm({...form, postCreated: e.target.value})} type="date" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
//     </div>
//     </div>

//     {/* <div className="col-md-6"> */}
//     {/**Post Category */}
//     {/* <label for="formGroupExampleInput" class="form-label">Category</label>
//     <div class="input-group input-group-sm mb-3">
//         <input ref={ref6} required value= {form.postCategory}  onChange={e => setForm({...form, postCategory: e.target.value})} type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm"/>
//     </div>
//     </div> */}

// {filenames.map((filename, index) => (
//             <div key={index} className="custom-file mb-4">
//               <input type="file" className="custom-file-input" id={`customFile-${index}`} style={{ display: 'none' }} />
//               <label className="custom-file-label" htmlFor={`customFile-${index}`}>
//                 {filename}    
//               </label>
//               <button type="button" onClick={() => onDeleteImage(index)} style={{color:"white", backgroundColor:"red", border:"1px solid red", borderRadius:"3px"}}>x</button>
//             </div>
//           ))}
//           <div className="row">
//           <div className="col-md-3">
//           <button type="button" className="btn btn-primary" onClick={addImageInput}>
//             + Add Cover Photo 
//           </button>
//           </div>
//           </div>

//           <div className="row mt-4">
//           {organizeImagesIntoRows().map((row, rowIndex) => (
//             <div className="row" key={rowIndex}>
//               {row.map((preview, index) => (
//                 <div className="col-md-4" key={index}>
//                   {/* <p  className="text-center">{filenames[index]}</p>
//                   <img style={{ width: '100%' }} src={preview} alt="Image Preview" /> */}
//                   <div className="container-1" >
//                   <img style={{ width: '100%' }} src={preview} alt="Image Preview" />
//                   <p  className="text-center">{filenames[index]}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             ))}
//             </div>
// </div>



//     {/**Post Body */}
//     <label for="formGroupExampleInput" class="form-label">Body </label>
//     {/* <div class="input-group input-group-sm mb-3">
//     <textarea ref={ref4}  value= {form.postBody}   onChange={e => setForm({...form, postBody: e.target.value})} class="form-control" required id="num-value" ></textarea>
//     </div> */}


//                 <CKEditor
//                     editor={ ClassicEditor }
//                     data={form.postBody}
//                     onReady={ editor => {
//                        // console.log( 'Editor is ready to use!', editor );
//                     } }
//                     onChange={ ( event, editor ) => {
//                       const data = editor.getData();
//                       setForm({...form, postBody: data})
//                   } }
//                     onBlur={ ( event, editor ) => {
//                        // console.log( 'Blur.', editor );
//                     } }
//                     onFocus={ ( event, editor ) => {
//                        // console.log( 'Focus.', editor );
//                     } }
//                 />
//                        <button type="button" onClick={onSubmit} class="btn btn-secondary" style={{marginTop:"20px"}}>Submit</button>
    
//     </form>
  
            
//         {message ? <p>{message}</p> : null}
//     </div>
// </>
//   );
// }
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../Sidebar';
import axios from 'axios'

// Updated CKEditor imports
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// Custom CKEditor build with upload adapter
// import CustomEditor from 'ckeditor5-custom-build/build/ckeditor';

import {optionProductsByProducts, category, tags} from '../Options';
import Multiselect from 'multiselect-react-dropdown';

// Custom upload adapter
class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file.then(file => {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('upload', file);
                
                axios.post(`${process.env.REACT_APP_API_URL}/upload-image`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': sessionStorage.getItem('token')
                    }
                })
                .then(response => {
                    if (response.data.url) {
                        resolve({
                            default: response.data.url
                        });
                    } else {
                        reject('Upload failed');
                    }
                })
                .catch(error => {
                    reject('Upload failed: ' + error);
                });
            });
        });
    }

    abort() {
        // Handle abort if needed
    }
}

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new MyUploadAdapter(loader);
    };
}

export default function EditBlogs() {
    {/**Images states */}
    const [files, setFiles] = useState([]);
    const [filenames, setFilenames] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [message, setMessage] = useState('');
    const [imagePreviews, setImagePreviews] = useState([]);

    //province items
    const [options, setOptions] = useState([])
    const [options2, setOptions2] = useState([])
    //options
    const [selectedOptions, setSelectedOptions] = useState([])
    const [selectedOptions2, setSelectedOptions2] = useState([])

    
    const [form, setForm] = useState({
        postTitle:'',
        postLink: '',
        postBody:'',
        postExcerpt:'',
        postCategory:[],
        postAuthor:'',
        postCreated:'',
        images: [],
    })

    const [editorConfig, setEditorConfig] = useState({
        extraPlugins: [MyCustomUploadAdapterPlugin],
        toolbar: {
            items: [
                'heading', '|',
                'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                'outdent', 'indent', '|',
                'imageUpload', 'blockQuote', 'insertTable', 'mediaEmbed', 'undo', 'redo'
            ]
        },
        image: {
            toolbar: [
                'imageTextAlternative', 'toggleImageCaption', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side'
            ]
        },
        simpleUpload: {
            uploadUrl: `${process.env.REACT_APP_API_URL}/upload-image`,
            headers: {
                'x-access-token': sessionStorage.getItem('token')
            }
        }
    });

    const ref1 = useRef()
    const ref2 = useRef()
    const ref3 = useRef()
    const ref4 = useRef()
    const ref5 = useRef()
    const ref6 = useRef()
    const ref7 = useRef()

    useEffect(()=>{
      setOptions(tags)
      setOptions2(category)
    }, [])

    //date formatting fixture
    function formatDateToYYYYMMDD(inputDate) {
        const dateObject = new Date(inputDate);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const day = String(dateObject.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
    }

    const {_id} = useParams()    
    const token = sessionStorage.getItem('token')

    const gerrit2 = async () =>{
        const response = await fetch(`${process.env.REACT_APP_API_URL}/find-blogs/${_id}`,{
          headers: {
            'x-access-token': token
          }
        })
        const data = await response.json()
        setForm({...form, 
        postTitle: data.postTitle,
        postLink: data.postLink,
        postBody: data.postBody,
        postExcerpt: data.postExcerpt,
        postTag: data.postTag,
        postCategory: data.postCategory,
        postAuthor:data.postAuthor,
        postCreated:data.postCreated,
        images: data.images,
        })
        setSelectedOptions(data.postTags || [])
        setSelectedOptions2(data.postCategory || [])
      }

    useEffect(()=>{
        gerrit2()
    },[])

    //dealing with multiple states
    const handleSelectStateOptions =  (selectedList)=>{
      setSelectedOptions(selectedList)
    }
    
    useEffect(()=>{
      setForm({...form, postCategory: selectedOptions})
    },[selectedOptions])

    const handleSelectStateOptions2 =  (selectedList)=>{
      setSelectedOptions2(selectedList)
    }
    
    useEffect(()=>{
      setForm({...form, postTags: selectedOptions2})
    },[selectedOptions2])

    const organizeImagesIntoRows = () => {
        const rows = [];
        for (let i = 0; i < imagePreviews.length; i += 3) {
          const row = imagePreviews.slice(i, i + 3);
          rows.push(row);
        }
        return rows;
    };
 
    const addImageInput = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.className = 'custom-file-input';
        input.required = true;
        input.multiple = false;
        input.addEventListener('change', onChange);
        input.click();
    };
  
    const onDeleteImage = (index) => {
        const newFiles = [...files];
        const newFilenames = [...filenames];
        const newImagePreviews = [...imagePreviews];
        newFiles.splice(index, 1);
        newFilenames.splice(index, 1);
        newImagePreviews.splice(index, 1);
        setFiles(newFiles);
        setFilenames(newFilenames);
        setImagePreviews(newImagePreviews);
        
        // Remove from form images array
        const newImages = [...form.images];
        newImages.splice(index, 1);
        setForm({...form, images: newImages});
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('form', JSON.stringify(form));
        
        if(files.length !== 0){
            for (let i = 0; i < files.length; i++) {
                formData.append('files', files[i]);
            }
        }
        
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/updated-blogs/${_id}`, formData, {
                headers:{
                    "Content-Type":"multipart/form-data",
                    'x-access-token': token
                }
            })
            setMessage('Blog updated successfully!');
        } catch (error) {
            setMessage('Error updating blog: ' + error.message);
        }
    }

    const onChange = (e) => {
        const selectedFiles = Array.from(e.target.files); 
        const selectedFilenames = selectedFiles.map((file) => file.name);
      
        const newImageObjects = selectedFiles.map((file) => ({
          img_url: `${process.env.REACT_APP_API_URL}/blogs/${file.name}`, 
          img_path: '/blogs/',
        }));
      
        setFiles([...files, ...selectedFiles]);
        setFilenames([...filenames, ...selectedFilenames]);
      
        setForm((prevObject) => ({
          ...prevObject,
          images: [...prevObject.images, ...newImageObjects],
        }));
      
        const previews = selectedFiles.map((file) => {
          const reader = new FileReader();
          return new Promise((resolve) => {
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(file);
          });
        });
      
        Promise.all(previews).then((previewData) => {
          setImagePreviews([...imagePreviews, ...previewData]);
        });
    };

    const reset = ()=>{
        setFilenames([])
        setFiles([])
        setUploadedFiles([])
        setImagePreviews([])
        setForm({
            postTitle:'',
            postLink: '',
            postBody:'',
            postExcerpt:'',
            postCategory:[],
            postAuthor:'',
            postCreated:'',
            images: [],
        })
        setSelectedOptions([])
        setSelectedOptions2([])
        
        if(ref1.current) ref1.current.value = ''
        if(ref2.current) ref2.current.value = ''
        if(ref3.current) ref3.current.value = ''
        if(ref4.current) ref4.current.value = ''
        if(ref5.current) ref5.current.value = ''
        if(ref6.current) ref6.current.value = ''
        if(ref7.current) ref7.current.value = ''
    }

  return (
    <>
        <div className="sidebar">
            <Sidebar/>
        </div>
        <div id="bydrop">
            <h1>Edit Blogs</h1>
            {message && <div className="alert alert-info">{message}</div>}
            
            <form onSubmit={onSubmit}>
                <div className="mb-3">
                    <label className="form-label">Tags</label>
                    <Multiselect 
                        options={options}
                        displayValue='name' 
                        selectedValues={selectedOptions}
                        onSelect={handleSelectStateOptions}
                        onRemove={handleSelectStateOptions}
                        closeOnSelect={false}
                        avoidHighlightFirstOption
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Category</label>
                    <Multiselect 
                        options={options2}
                        displayValue='name' 
                        selectedValues={selectedOptions2}
                        onSelect={handleSelectStateOptions2}
                        onRemove={handleSelectStateOptions2}
                        closeOnSelect={false}
                        avoidHighlightFirstOption
                    />
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Title</label>
                        <div className="input-group input-group-sm mb-3">
                            <input required ref={ref1} value={form.postTitle} onChange={e => setForm({...form, postTitle: e.target.value})} type="text" className="form-control" />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Author</label>
                        <div className="input-group input-group-sm mb-3">
                            <input required ref={ref2} value={form.postAuthor} onChange={e => setForm({...form, postAuthor: e.target.value})} type="text" className="form-control" />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Excerpt</label>
                        <div className="input-group input-group-sm mb-3">
                            <input ref={ref5} required value={form.postExcerpt} onChange={e => setForm({...form, postExcerpt: e.target.value})} type="text" className="form-control" />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Link</label>
                        <div className="input-group input-group-sm mb-3">
                            <input ref={ref7} required value={form.postLink} onChange={e => setForm({...form, postLink: e.target.value})} type="text" className="form-control" />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Date</label>
                        <div className="input-group input-group-sm mb-3">
                            <input required ref={ref3} value={formatDateToYYYYMMDD(form.postCreated)} onChange={e => setForm({...form, postCreated: e.target.value})} type="date" className="form-control" />
                        </div>
                    </div>
                </div>

                {/* Cover Images Section */}
                <div className="mb-3">
                    {filenames.map((filename, index) => (
                        <div key={index} className="custom-file mb-2">
                            <input type="file" className="custom-file-input" style={{ display: 'none' }} />
                            <label className="custom-file-label">
                                {filename}    
                            </label>
                            <button type="button" onClick={() => onDeleteImage(index)} className="btn btn-danger btn-sm ms-2">x</button>
                        </div>
                    ))}
                    
                    <button type="button" className="btn btn-primary" onClick={addImageInput}>
                        + Add Cover Photo 
                    </button>
                </div>

                <div className="row mt-4">
                    {organizeImagesIntoRows().map((row, rowIndex) => (
                        <div className="row mb-3" key={rowIndex}>
                            {row.map((preview, index) => (
                                <div className="col-md-4" key={index}>
                                    <div className="container-1">
                                        <img style={{ width: '100%', height: '200px', objectFit: 'cover' }} src={preview} alt="Preview" />
                                        <p className="text-center small">{filenames[rowIndex * 3 + index]}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                {/* CKEditor Section */}
                <div className="mb-3">
                    <label className="form-label">Body</label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={form.postBody}
                        config={editorConfig}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setForm({...form, postBody: data});
                        }}
                    />
                </div>

                <div className="mt-3">
                    <button type="submit" className="btn btn-primary me-2">Update Blog</button>
                    <button type="button" onClick={reset} className="btn btn-secondary">Reset</button>
                </div>
            </form>
        </div>
    </>
  );
}